/**
 * Persistence for done state
 */

export type DoneMeta = {
  markedAt: number; // timestamp
  eventUid: string;
};

export const DONE_STORAGE_KEY = "aitu_schedule_done_v1";
